import React from 'react'
import * as pathname from './pathname'
import { MODULES, GROUPS, METHOD } from '../../utils/constants/roles'
import CashRegisters from '../../views/cash-registers/CashRegisters.tsx'

const cashRegistersRoutes = [
  {
    path: pathname.cashRegistersPathnames.CASH_REGISTERS,
    name: 'cashRegisters',
    element: <CashRegisters />,
    role: {
      module: MODULES.CENTERS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
]

export { cashRegistersRoutes }
